import {useQuery} from '@tanstack/react-query'

import {toast} from 'react-toastify'
import useRequestParams from 'src/feature/bite/hook/request'
import {useExports} from '../hook/list'
import {API} from 'src/feature/bite/domain'

export function useGetList() {
  const {listFilter} = useExports()
  const {auth, headers, errorMessage, signOut} = useRequestParams()

  const userID = auth()?.id

  return useQuery(
    ['getallExportFile', listFilter],
    async () => {
      const Response = await fetch(`${API}/ExportFile/GetAllExportFile`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...listFilter,
          userID,
          language: headers.Language,
        }),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()

      return Data
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}

export function useImportGetList() {
  const {listFilter} = useExports()
  const {auth, headers, errorMessage, signOut} = useRequestParams()

  const userID = auth()?.id

  return useQuery(
    ['getallImportFile', listFilter],
    async () => {
      const Response = await fetch(`${API}/StoreProduct/UploadedProductFileList`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...listFilter,
          userID,
          language: headers.Language,
        }),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()

      return Data
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}
